import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../sections/Hero";
import Hours from "../sections/Hours";
import TrustStrip from "../sections/TrustStrip";
import About from "../sections/About";
import Services from "../sections/Services";
import WhyChoose from "../sections/WhyChoose";
import Gallery from "../sections/Gallery";
import Contact from "../sections/Contact";
import { scrollToId } from "../components/Nav";
import usePageMeta from "../usePageMeta";

export default function Home() {
  usePageMeta(
    "No. 1 Nails & Spa — Manly, Sydney NSW",
    "Premium nail care in the heart of Manly. Gel manicures, acrylic nails, spa pedicures. Book online or call (02) 9977 8488."
  );
  const { hash } = useLocation();

  // Arriving from another page with /#services etc. — scroll once the page has painted.
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 120);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main id="home">
      <Hero />
      <Hours />
      <TrustStrip />
      <About />
      <Services />
      <WhyChoose />
      <Gallery />
      <Contact />
    </main>
  );
}
